
import React from 'react';
import MetricCard from '../MetricCard';

interface CallsAnsweredMetricProps {
  callsAnsweredPercentage: number;
  timeFrame?: string;
  noData?: boolean;
}

const CallsAnsweredMetric: React.FC<CallsAnsweredMetricProps> = ({ 
  callsAnsweredPercentage,
  timeFrame = 'Past 30 days',
  noData = false
}) => {
  // Determine the color and style settings based on percentage
  const getProgressStyles = () => {
    if (callsAnsweredPercentage === 0) {
      return {
        color: 'linear-gradient(90deg, #ea384c, #ff5a5a)',
        rightLabel: '', // Empty string to hide the 100% label
        max: 100,
        className: 'pulse-red-effect',
        textColorClass: 'text-[#ea384c]',
        showZeroProgress: true,
        hideRightLabel: true // Explicit flag to hide right label
      };
    } else if (callsAnsweredPercentage < 60) {
      return {
        color: 'linear-gradient(90deg, #ea384c, #ff5a5a)',
        className: callsAnsweredPercentage < 40 ? 'pulse-red-effect' : '',
        max: 100,
        rightLabel: '100%',
        textColorClass: 'text-[#ea384c]',
        hideRightLabel: false
      };
    } else if (callsAnsweredPercentage < 80) {
      return {
        color: 'linear-gradient(90deg, #F97316, #FDBA74)',
        max: 100,
        rightLabel: '100%',
        textColorClass: 'text-[#F97316]',
        hideRightLabel: false
      };
    } else if (callsAnsweredPercentage === 100) {
      // Special case for 100% - solid green with checkmark
      return {
        color: '#00d023', // Solid green
        max: 100,
        rightLabel: '100%',
        textColorClass: '',
        hideRightLabel: false,
        className: 'rainbow-pulse-effect'
      };
    } else {
      return {
        color: 'linear-gradient(90deg, #00d023, #82e167)',
        max: 100,
        rightLabel: '100%',
        textColorClass: '',
        hideRightLabel: false
      };
    }
  };

  const styles = getProgressStyles();

  return (
    <div className="relative">
      <MetricCard 
        title="Calls Answered" 
        value={`${callsAnsweredPercentage}%`} 
        min={0} 
        max={styles.max} 
        current={callsAnsweredPercentage} 
        progressColor={styles.color}
        rightLabel={styles.rightLabel}
        hideMinLabel={true}
        className={styles.className}
        textColorClass={styles.textColorClass}
        showZeroProgress={styles.showZeroProgress}
        hideRightLabel={styles.hideRightLabel}
        tooltip={`Percentage of calls that were answered (${timeFrame})`}
        noData={noData}
        preserveHeight={true} // Add this prop to maintain consistent height
        hideProgress={false}
      />
      <style>
        {`
        @keyframes pulseRed {
          0% { opacity: 0.7; }
          50% { opacity: 1; }
          100% { opacity: 0.7; }
        }
        
        .pulse-red-effect {
          animation: pulseRed 1s infinite;
        }
        `}
      </style>
    </div>
  );
};

export default CallsAnsweredMetric;

